module.exports = __webpack_public_path__ + "img/bg.d22d54b6.jpg";